<template>
  <div class="row">
    <el-dialog
      left
      :title="title"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      @close="handleCancel()"
      :visible.sync="isShow"
      width="500px"
      style="margin: 0 auto"
      class="valuationRoundMdlCls col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <div
        style="margin-bottom: 20px"
        v-if="value.previous_round && value.previous_round._id"
      >
        <div style="margin-bottom: 15px">Previous Round Details</div>
        <div class="row mb-2">
          <div class="col-6">Round</div>
          <div class="col-6 previousValue" v-if="value.previous_round.offering">
            {{ value.previous_round.offering }}
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-6">Date</div>
          <div class="col-6 previousValue" v-if="value.previous_round.date">
            {{ moment(value.previous_round.date).format("MM/DD/YYYY") }}
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-6">Pre $</div>
          <div class="col-6 previousValue" v-if="value.previous_round.preMoney">
            {{ value.previous_round.preMoney }}
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-6">Round Size</div>
          <div
            class="col-6 previousValue"
            v-if="value.previous_round.roundSize"
          >
            {{ value.previous_round.roundSize }}
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-6">Post $</div>
          <div
            class="col-6 previousValue"
            v-if="value.previous_round.postMoney"
          >
            {{ value.previous_round.postMoney }}
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-6">PPS $</div>
          <div
            class="col-6 previousValue"
            v-if="value.previous_round.pricePerShare"
          >
            {{ value.previous_round.pricePerShare }}
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-6">Verified</div>
          <div class="col-6 previousValue">
            {{ value.previous_round.isVerified ? "Yes" : "No" }}
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-6">Lead Investor</div>
          <div class="col-6 previousValue">
            {{
              value.previous_round.leadInvestor
                ? value.previous_round.leadInvestor
                : "-"
            }}
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-6">Did you Participate?</div>
          <div class="col-6 previousValue">
            {{ value.previous_round.isParticipated ? "Yes" : "No" }}
          </div>
        </div>
        <!-- <div class="row mb-2">
          <div class="col-6">Participated</div>
          <div class="col-6 previousValue">{{value.previous_round.isParticipated ?"Yes":"No"}}</div>
        </div>-->
      </div>
      <div
        style="margin-bottom: 15px"
        v-if="value.previous_round && value.previous_round._id"
      >
        {{ value.isCreate ? "Add New Round" : "Edit Round" }}
      </div>
      <form @submit.prevent="handleSave">
        <div class="row">
          <div class="col-6">
            <div>Round</div>
            <el-select
              class="todo-dropdown-el-select"
              v-model="value.data.offering"
              size="large"
              placeholder="Round"
            >
              <el-option
                v-for="item in vals.INVESTMENT_OFFERINGS"
                :value="item"
                :label="item"
                :key="item"
              ></el-option>
            </el-select>
          </div>
          <div class="col-6">
            <div>Date</div>
            <input
              class="todo-form-date todo-form form-control"
              type="date"
              :value="
                value.data.date &&
                moment.utc(value.data.date).format('YYYY-MM-DD')
                  ? moment.utc(value.data.date).format('YYYY-MM-DD')
                  : moment.utc(new Date()).format('YYYY-MM-DD')
              "
              @input="value.data.date = moment($event.target.valueAsDate)"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div>Pre $</div>
            <input
              type="Number"
              class="form-control"
              min="0"
              placeholder="Pre $"
              v-model="value.data.preMoney"
            />
          </div>
          <div class="col-6">
            <div>Post $</div>
            <input
              type="Number"
              class="form-control"
              min="0"
              placeholder="Post $"
              v-model="value.data.postMoney"
            />
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-6">
            <div>Price Per Share</div>
            <input
              class="form-control"
              @keypress="onlyForCurrency"
              placeholder="Price Per Share"
              v-model="value.data.pricePerShare"
            />
          </div>
          <div class="col-6">
            <div>Lead Investor</div>
            <input
              type="text"
              class="form-control"
              placeholder="Lead Investor"
              v-model="value.data.leadInvestor"
            />
          </div>
        </div>
        <div class="row" style="margin-right: 5px">
          <div class="col-6">
            <div class="d-flex">
              <div style="margin-top: auto; margin-bottom: auto">Verified</div>
              <label class="switchValuationToggle">
                <input
                  type="checkbox"
                  id="togBtn"
                  v-model="value.data.isVerified"
                />
                <div class="sliderValuationToggle round"></div>
              </label>
            </div>
          </div>
          <div class="col-6">
            <div class="d-flex">
              <div style="margin-top: auto; margin-bottom: auto">
                Did you Participate?
              </div>
              <label class="switchValuationToggle">
                <input
                  type="checkbox"
                  id="togBtn"
                  v-model="value.data.isParticipated"
                />
                <div class="sliderValuationToggle round"></div>
              </label>
            </div>
          </div>
          <!-- <div class="col-6">
            <div class="d-flex">
              <div style="margin-top:auto;margin-bottom:auto">Participated</div>
              <label class="switchValuationToggle">
                <input type="checkbox" id="togBtn" v-model="value.data.isParticipated" />
                <div class="sliderValuationToggle round"></div>
              </label>
            </div>
          </div>-->
        </div>

        <!-- Add Investment -->
        <div v-if="value.data.isParticipated" >
        <div class="addInvestmentTitle">
          <p>Add Investment</p>
        </div>
        <div class="row">
          <div class="col-6">
            <div>
              Investment Type
              <span class="required">*</span>
            </div>
            <el-select
              class="todo-dropdown-el-select"
              v-model="value.data.investment_type"
              :disabled="checkTypeDisabled"
              size="large"
              placeholder="Investment Type"
            >
              <el-option
                v-for="item in vals.INVESTMENT_TYPE"
                :value="item"
                :label="item"
                :key="item"
              ></el-option>
            </el-select>
          </div>
          <!-- <div class="col-6">
            <div>
              Round
              <span class="required">*</span>
            </div>
            <el-select
              class="todo-dropdown-el-select"
              v-model="value.data.offering"
              size="large"
              placeholder="Round"
            >
              <el-option
                v-for="item in vals.INVESTMENT_OFFERINGS"
                :value="item"
                :label="item"
                :key="item"
              ></el-option>
            </el-select>
          </div> -->
        </div>
        <div class="row">
          <div class="col-6" v-if="showAmount">
            <div>Amount ($)</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              step=".01"
              v-model="value.data.amount"
              placeholder="Amount ($)"
              min="0"
            />
          </div>
          <div
            class="col-6"
            v-else-if="value.data.investment_type == 'Warrant'"
          >
            <div>Exercise Price ($)</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              step=".01"
              v-model="value.data.excerise_price"
              placeholder="Exercise Price ($)"
              min="0"
            />
          </div>
          <div class="col-6" v-else-if="value.data.investment_type == 'Equity'">
            <div>Price per share ($)</div>
            <b-input
              class="form-control team-form"
              style="width: 100%"
              @keypress="onlyForCurrency"
              @keyup="calculateAmount"
              v-model="value.data.price_per_share"
              placeholder="Price per share ($)"
              min="0"
            />
          </div>
          <div
            class="col-6"
            v-else-if="value.data.investment_type == 'Proceeds'"
          >
            <div>Investment Proceeds Type</div>
            <el-select
              class="todo-dropdown-el-select"
              v-model="value.data.investment_proceeds_type"
              size="large"
              placeholder="Type"
            >
              <el-option
                v-for="item in vals.INVESTMENT_PROCEEDS_TYPE"
                :value="item"
                :label="item"
                :key="item"
              ></el-option>
            </el-select>
          </div>
          <div class="col-6">
            <div>Investment Date</div>
            <input
              class="form-control team-form"
              style="width: 100%"
              :max="moment().format('YYYY-MM-DD')"
              min="2000-01-01"
              type="date"
              :value="
                value.data.transaction_date &&
                  moment.utc(value.data.transaction_date).format('YYYY-MM-DD')
              "
              @input="
                value.data.transaction_date = moment($event.target.valueAsDate)
              "
              placeholder="Current Cost"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-6" v-if="showCap">
            <div>Cap ($)</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              step=".01"
              v-model="value.data.cap"
              placeholder="Cap ($)"
            />
          </div>
          <div
            class="col-6"
            v-else-if="value.data.investment_type == 'Warrant'"
          >
            <div>Terms(years)</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              v-model="value.data.term_years"
              placeholder="Terms(years)"
              min="0"
              step=".1"
            />
          </div>
          <div class="col-6" v-else-if="value.data.investment_type == 'Equity'">
            <div>No. of shares (#)</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              @keyup="calculateAmount"
              v-model="value.data.no_of_shares"
              placeholder="No. of shares (#)"
              min="0"
            />
          </div>
          <div
            class="col-6"
            v-else-if="value.data.investment_type == 'Proceeds'"
          >
            <div>Amount ($)</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              step=".01"
              v-model="value.data.proceeds_amount"
              placeholder="Amount ($)"
              min="0"
            />
          </div>
          <div class="col-6" v-if="showDiscount">
            <div>Discount (%)</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              v-model="value.data.discount"
              placeholder="Discount (%)"
              min="0"
              max="100"
              step=".01"
            />
          </div>
          <div
            class="col-6"
            v-else-if="value.data.investment_type == 'Warrant'"
          >
            <div>Coverage (%)</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              v-model="value.data.coverage"
              placeholder="Coverage (%)"
              min="0"
              max="100"
            />
          </div>
          <div
            class="col-6"
            v-else-if="value.data.investment_type == 'Bridge Loan'"
          >
            <div>Interest (%)</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              v-model="value.data.interest_rate"
              placeholder="Interest (%)"
              min="0"
            />
          </div>
          <div class="col-6" v-else-if="value.data.investment_type == 'Equity'">
            <div>Amount ($)</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              step=".01"
              @keyup="calculateShareCount"
              v-model="value.data.amount"
              placeholder="Amount ($)"
              min="0"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-6" v-if="showEquityStanding">
            <div>Equity (%)</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              v-model="value.data.equity_standing"
              placeholder="Equity (%)"
              min="0"
              max="100"
              step=".01"
            />
          </div>
          <div
            class="col-6"
            v-else-if="value.data.investment_type == 'Convertible Note'"
          >
            <div>Interest (%)</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              v-model="value.data.interest"
              placeholder="Interest (%)"
              min="0"
              max="100"
            />
          </div>
          <div
            class="col-6"
            v-else-if="value.data.investment_type == 'Warrant'"
          >
            <div>Maturity Date</div>
            <input
              class="form-control team-form"
              style="width: 100%"
              :max="moment().format('YYYY-MM-DD')"
              min="2000-01-01"
              type="date"
              :value="
                value.data.maturity_date &&
                  moment(value.data.maturity_date).format('YYYY-MM-DD')
              "
              @input="
                value.data.maturity_date = moment($event.target.valueAsDate)
              "
              placeholder="Maturity Date"
            />
          </div>
          <div
            class="col-6"
            v-else-if="value.data.investment_type == 'Bridge Loan'"
          >
            <div>Due Date</div>
            <input
              class="form-control team-form"
              style="width: 100%"
              min="2000-01-01"
              type="date"
              :value="
                value.data.due_date &&
                  moment(value.data.due_date).format('YYYY-MM-DD')
              "
              @input="value.data.due_date = moment($event.target.valueAsDate)"
              placeholder="Maturity Date"
            />
          </div>
          <div class="col-6">
            <div>Current Value</div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%"
              v-model="value.data.currentValue"
              placeholder="Value"
              min="0"
              step=".01"
            />
          </div>
        </div>
        <div class="row" v-if="value.data.investment_type == 'Warrant'">
          <div class="col-12">
            <div>Security</div>
            <input
              type="text"
              class="form-control team-form"
              style="width: 100%"
              v-model="value.data.security"
              placeholder="Security"
              min="0"
            />
          </div>
        </div>
        <div class="row" style="margin-bottom: 6px">
          <div class="col-6">
            <div class="d-flex">
              <b-form-checkbox
                v-model="value.data.is_prorata"
                name="checkbox-1"
                value="true"
                unchecked-value="false"
                :disabled="isIPOAcquisitionStatus()"
              ></b-form-checkbox>
              <span style="margin-top: 3px">Pro Rata Rights</span>
            </div>
          </div>
          <div class="col-6">
            <div class="d-flex">
              <b-form-checkbox
                v-model="value.data.information_rights"
                name="checkbox-1"
                value="true"
                unchecked-value="false"
                :disabled="isIPOAcquisitionStatus()"
              ></b-form-checkbox>
              <span style="margin-top: 3px">Information Rights</span>
            </div>
          </div>
        </div>
        <div class="row" style="margin-bottom: 6px">
          <div class="col-6">
            <div class="d-flex">
              <b-form-checkbox
                v-model="value.data.is_lead_investor"
                name="checkbox-1"
                value="true"
                unchecked-value="false"
              ></b-form-checkbox>
              <span style="margin-top: 3px">Lead Investor</span>
            </div>
          </div>
          <div class="col-6">
            <div class="d-flex">
              <b-form-checkbox
                v-model="value.data.board_seat"
                name="checkbox-1"
                value="true"
                unchecked-value="false"
              ></b-form-checkbox>
              <span style="margin-top: 3px">Board Seat</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div>Notes</div>
            <textarea
              placeholder="Notes"
              rows="5"
              cols="50"
              class="form-control"
              spellcheck="false"
              v-model="value.data.notes"
            ></textarea>
          </div>
        </div>
        <div style="padding-bottom: 3px">Attachments</div>
        <div class="row m-0">
          <div
            class="col-4 attach-class"
            id="popover-target-2"
            style="padding-top: 6px"
          >
            <i class="fa fa-paperclip" aria-hidden="true"></i>
            Attach a file
            <input
              type="file"
              ref="fileBtn"
              if="fileId"
              @change="handleFile"
              class="hidden"
            />
          </div>
          <b-popover
            target="popover-target-2"
            triggers="hover"
            placement="top"
            custom-class="popover-modal-class"
          >
            <div
              class="m-2"
              style="cursor: pointer"
              @click="
                $refs.fileBtn.click();
                typeUrlCheck = false;
              "
            >
              From Computer
            </div>
            <div
              class="m-2"
              style="cursor: pointer"
              @click="typeUrlCheck = !typeUrlCheck"
            >
              Add Link
            </div>
          </b-popover>
          <div
            class="col-8 drag-drop-class"
            style="padding-top: 6px"
            v-if="!typeUrlCheck"
            v-cloak
            @drop.prevent="addFile"
            @dragover.prevent
          >
            Drag and drop file to attach
          </div>
          <div class="col-8" style="padding: 0" v-else>
            <form @submit.prevent="submitUrl">
              <input
                type="text"
                class="form-control team-form url-input-form"
                placeholder="Add a URL"
                id="myInput"
                @blur="submitUrl"
                v-model="urlValue"
                @
              />
            </form>
          </div>
        </div>
        <div class="mt-3">
          <div v-if="url.add">
            <div
              v-for="(item, index) in url.add"
              :key="index"
              class="fileItem my-2"
            >
              <a :href="formatUrl(item)" target="_blank">
                <span class="attachment-name-class">{{ item }}</span>
              </a>
              <i
                class="fas fa-times"
                @click="deleteURL(index, 'add')"
                style="
                  float: right;
                  padding-top: 5px;
                  margin-right: 18px;
                  cursor: pointer;
                "
              ></i>
            </div>
          </div>
          <div v-if="url.update">
            <div
              v-for="(item, index) in url.update"
              :key="index"
              class="fileItem my-2"
            >
              <a :href="formatUrl(item.url)" target="_blank">
                <span class="attachment-name-class">{{ item.url }}</span>
              </a>
              <i
                class="fas fa-times"
                @click="deleteURL(index, 'update')"
                style="
                  float: right;
                  padding-top: 5px;
                  margin-right: 18px;
                  cursor: pointer;
                "
              ></i>
            </div>
          </div>
          <div v-if="files.add">
            <div
              v-for="(item, index) in files.add"
              :key="index"
              class="d-flex fileItem my-2"
            >
              <i
                v-if="
                  item.type.includes('.doc') ||
                    item.name.includes('.doc') ||
                    item.name.includes('.txt')
                "
                class="fas fa-file-word mr-2 mt-1"
                style="color: #5190ff"
              ></i>
              <i
                v-else-if="
                  item.type.includes('zip') ||
                    item.name.includes('.zip') ||
                    item.type.includes('rar') ||
                    item.name.includes('.rar')
                "
                class="far fa-file-archive mr-2 mt-1"
              ></i>
              <i
                v-else-if="item.type.includes('image')"
                class="fas fa-image mr-2"
              ></i>
              <i
                v-else-if="
                  item.type.includes('csv') ||
                    item.type.includes('xls') ||
                    item.name.includes('.csv') ||
                    item.name.includes('.xls')
                "
                class="fas fa-file-excel mr-2 mt-1"
                style="color: #f15643"
              ></i>
              <i
                v-else-if="
                  item.type.includes('pdf') || item.type.includes('.pdf')
                "
                class="fas fa-file-pdf mr-2 mt-1"
                style="color: #f15643"
              ></i>
              <span
                class="attachment-name-class"
                @click="handleDownload(item, 'file')"
                style="cursor: pointer"
                >{{ item.name }}</span
              >
              <i
                class="fas fa-times"
                @click="deleteFile(index, 'add')"
                style="
                  float: right;
                  padding-top: 5px;
                  margin-right: 18px;
                  cursor: pointer;
                "
              ></i>
            </div>
          </div>
          <div v-if="files.update">
            <div
              v-for="(item, index) in files.update"
              :key="index"
              class="d-flex fileItem my-2"
            >
              <i
                v-if="item.name.includes('.doc')"
                style="color: #5190ff"
                class="fas fa-file-word mr-2 mt-1"
              ></i>
              <i
                v-else-if="
                  item.name.includes('zip') || item.name.includes('.rar')
                "
                class="far fa-file-archive mr-2 mt-1"
              ></i>
              <i
                v-else-if="
                  item.name.includes('.jpg') || item.name.includes('.png')
                "
                class="fas fa-image mr-2 mt-1"
              ></i>
              <i
                v-else-if="
                  item.name.includes('.csv') || item.name.includes('.xls')
                "
                class="fas fa-file-excel mr-2 mt-1"
                style="color: #f15643"
              ></i>
              <i
                v-else-if="item.name.includes('.pdf')"
                style="color: #f15643"
                class="fas fa-file-pdf mr-2 mt-1"
              ></i>
              <span
                class="attachment-name-class"
                @click="handleDownload(item, 's3')"
                style="cursor: pointer"
                >{{ item.name }}</span
              >
              <i
                class="fas fa-times"
                @click="deleteFile(index, 'update')"
                style="
                  float: right;
                  padding-top: 5px;
                  margin-right: 18px;
                  cursor: pointer;
                "
              ></i>
            </div>
          </div>
        </div>
        </div>

        <div slot="footer" class="dialog-footer" style>
          <div
            class="col-xl edit-company-action-button-row"
            style="padding: 0px; margin-top: 30px"
          >
            <button
              type="button"
              class="todo-form-cancel-button btn-outline-secondary"
              @click.prevent="handleCancel()"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="todo-form-submit-button btn btn-primary"
              :disabled="isSaving"
            >
              Save
              <b-spinner
                v-if="isSaving"
                style="float: right"
                small
                label="Loading..."
              ></b-spinner>
            </button>
          </div>
        </div>
      </form>
    </el-dialog>
  </div>
</template>
<script>
import { Dialog } from "element-ui";
import moment from "moment";
import { Select, Option } from "element-ui";
import { vals } from "../../../util";
import api from "../../../axios_api";
import router from "../../../main";
export default {
  components: {
    [Dialog.name]: Dialog,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  props: {
    value: {
      isCreate: Boolean,
      data: Object,
      isShow: Boolean,
      portfolio_item: String,
      previous_round: Object,
    },
    organization: "",
    investmentData: Object,
    contactEmail: String,
    lastFundingRoundDate: String,
    currentCompany: Object,
    context: String,
    investments: Array,
    default: () => {
      return [];
    }
  },
  computed: {
    moment() {
      return moment;
    },
    isShow: {
      get() {
        return this.value.isShow;
      },
      set(value) {
        this.value.isShow = value;
      },
    },
    isVerifiedValue() {
      return this.isVerified;
    },
    title() {
      if (this.value.isCreate) return "Add Round";
      else return "Edit Round";
    },
    showAmount() {
      let display = false;
      if (
        this.value.data.investment_type == "SAFE Note" ||
        this.value.data.investment_type == "Convertible Note" ||
        this.value.data.investment_type == "Bridge Loan" ||
        this.value.data.investment_type == "Unknown"
      )
        return (display = true);
    },
    showCap() {
      let display = false;
      if (
        this.value.data.investment_type == "SAFE Note" ||
        this.value.data.investment_type == "Convertible Note" ||
        this.value.data.investment_type == "Bridge Loan"
      )
        return (display = true);
    },
    showDiscount() {
      let display = false;
      if (
        this.value.data.investment_type == "SAFE Note" ||
        this.value.data.investment_type == "Convertible Note"
      )
        return (display = true);
    },
    showEquityStanding() {
      let display = false;
      if (
        this.value.data.investment_type == "SAFE Note" ||
        this.value.data.investment_type == "Equity" ||
        this.value.data.investment_type == "Proceeds" ||
        this.value.data.investment_type == "Unknown"
      )
        return (display = true);
    },
  },
  data() {
    return {
      vals,
      syncToogle: true,
      isSaving: false,
      isVerified: false,
      checkTypeDisabled: false,
      typeUrlCheck: false,
      urlValue: "",
      files: {
        add: [],
        update: [],
        delete: []
      },
      url: {
        add: [],
        update: [],
        delete: []
      },
    };
  },
  watch:{
    isShow: function(val) {
      if (val) {
        this.setUploadedFiles();
        this.checkInvestmentType();
        // this.setReferredBy();
      }
    }
  },
  methods: {
    checkInvestmentType() {
      this.checkTypeDisabled = false;
      if (
        !this.value.isCreate &&
        this.value.data.investment_type.includes("Proceeds")
      ) {
        this.checkTypeDisabled = true;
      }
    },
    async setUploadedFiles() {
      this.files = { add: [], delete: [], update: [] };
      let uploadedDocs = [];
      if (!this.value.isCreate && this.value.data._id) {
        uploadedDocs = await this.$store.getters["file/filesByInvestmentId"](
          this.value.data._id
        );
      }

      if (uploadedDocs.length) {
        uploadedDocs.map(item => {
          if (item.link_type == "File") this.files.update.push(item);
          else this.url.update.push(item);
        });
      }
    },
    calculateAmount() {
      let total = 0;

      if (this.value.data.no_of_shares && this.value.data.price_per_share) {
        total = this.value.data.no_of_shares * this.value.data.price_per_share;
      }

      this.value.data.amount = total;

      this.$forceUpdate();
    },
    calculateShareCount() {
      let total = 0;
      if (this.value.data.amount && this.value.data.price_per_share) {
        total = this.value.data.amount / this.value.data.price_per_share;
      }

      this.value.data.no_of_shares = total;

      this.$forceUpdate();
    },
    isIPOAcquisitionStatus() {
      return (
        this.currentCompany &&
        (this.currentCompany.status === "IPO" ||
          this.currentCompany.status === "Acquired")
      );
    },
    handleFile(e) {
      let droppedFiles = e.target.files;
      if (!droppedFiles) return;
      [...droppedFiles].forEach(f => {
        this.files.add.push(f);
      });
    },
    deleteFile(index, type) {
      if (type == "add") this.files.add.splice(index, 1);
      else {
        let data = this.files.update.splice(index, 1);
        this.files.delete.push(data[0]);
      }
    },

    onChangeEventHandler() {
      this.syncToogle = false;
    },
    handleSave() {
      this.isSaving = true;
      this.saveRound();
      if(this.value.data.isParticipated){
        this.saveInvestment();
      }
    },
    saveRound(){
      let serverData = JSON.parse(JSON.stringify(this.value.data));
      serverData.roundSize =
        Number(serverData.postMoney) - Number(serverData.preMoney).toFixed(2);
      serverData.source = "User";
      if (this.value.isCreate) {
        if (this.value.portfolio_item) {
          api
            .post(
              `/${this.$route.params.account_id}/${this.$route.params.workspace_id}/${this.value.data.portfolio_item}/valuation`,
              {
                encrypt: {
                  data: serverData,
                },
              }
            )
            .then((data) => {
              // console.log("data : ", data);
              this.$emit("save-refresh");
              if(!this.value.data.isParticipated){
                this.handleCancel();
                this.$toaster.success("Saved Successfully.");
              }
              
              //User Perform action is updated in backend post api
            })
            .catch((error) => {
              // console.log("error in inserting valuation data", error);
              this.isSaving = false;
              this.$toaster.error("Failed to Insert !!!");
            });
        }
      } else {
        if (serverData._id) {
          api
            .patch(
              `/${this.$route.params.account_id}/${serverData._id}/valuation`,
              {
                encrypt: {
                  data: serverData,
                },
              }
            )
            .then((data) => {
              this.$emit("save-refresh");
              if(!this.value.data.isParticipated){
              this.handleCancel();
              this.$toaster.success("Saved Successfully.");
              }
            })
            .catch((error) => {
              // console.log("error in inserting valuation data", error);
              this.$toaster.error("Failed to Update !!!");
            });
        }
      }
    },
    InvestmentSave() {
      let self = this;
      if (!this.value.data.offering) {
        this.$toaster.error("Missing required Parameter:Offering");
        return;
      }

      // check if `Information Rights` is checked and this is the first investment.
      // if (this.value.data.information_rights === "true" && !this.investments.length) {
      if (!this.investments.length) {
        this.showFounderEmailConfirm = true;
      } else {
        self.saveInvestment();
      }
    },
    saveInvestment() {
      let self = this;

      if (this.urlValue) {
        this.url.add.push(this.urlValue);
        this.urlValue = "";
      }
      let currentCompany = JSON.parse(JSON.stringify(self.currentCompany));
      this.isSaving = true;
      if (this.value.data.notes == undefined) {
        delete this.value.data.notes;
        delete this.value.data.noteId;
      }
      if (this.referred_by_tags)
        this.value.data.referred_by = this.referred_by_tags;
      if (this.value.isCreate) {
        self.company_name = this.value.data.company_name || "";

        self.value.data.transaction_date = self.value.data.transaction_date
          ? self.value.data.transaction_date
          : new Date();

        try {
          const x = self.value.data.transaction_date
            ? self.value.data.transaction_date
            : new Date();
          self.value.data.transaction_date = x.local(); //.format("MM/DD/YYYY");
        } catch (e) {}

        this.$store
          .dispatch("investment/createInvestment", this.value.data)
          .then(inserteddata => {

            if (!this.investments.length) {
              let url = `${router.currentRoute.params.account_id}/${router.currentRoute.params.workspace_id}/investment-mail`;

              console.log("sending email to: ", self.contactEmail);
              api
                .post(url, {
                  encrypt: {
                    data: {
                      emails: [self.contactEmail],
                      subject: "Fiifi | KPI Update",
                      portfolio_item: self.value.data.portfolio_item,
                      account: router.currentRoute.params.account_id,
                      companyName: self.company_name
                    }
                  }
                })
                .then(() => {});
            }

            if (
              self.$parent &&
              self.$parent.$refs.noteRef &&
              self.$parent.$refs.noteRef
            )
              self.$parent.$refs.noteRef.getNotes();
            if (self.context == "company-profile") {
              self.handleCost();
            }
            let serverData = {};
            if (
              !self.valueCheck &&
              self.currentCompany.value != self.value.data.currentValue
            ) {
              serverData._id = self.currentCompany._id;
              serverData.__v = self.currentCompany.__v;
              serverData.value = self.value.data.currentValue;
            } else {
              serverData._id = self.currentCompany._id;
              serverData.__v = self.currentCompany.__v;
            }

            let path = "company/apiPatchCompanyInst";
            this.$store.dispatch(path, serverData).then(response => {
              self.$store
                .dispatch("portfolio/_apiFetchPortfolio")
                .then(data => {
                  if (self.$parent && self.$parent.tabulator) {
                    let data = self.$store.getters["portfolio/portfolioData"];
                    self.$parent.tabulator.updateData(data);
                  }
                  if (
                    self.currentCompany.value != self.value.data.currentValue
                  ) {
                    this.$toaster.success("Current Value Updated");
                  }
                });
            });

            api
              .get(`/portfolio/investments/${inserteddata.portfolio_item}`)
              .then(data => {
                //self.handleCost();
                self.$emit("investment-save", data.data.encrypt.success);
                // if (
                //   data &&
                //   data.data.encrypt.success &&
                //   data.data.encrypt.success.length == 1
                // ) {
                //   self.$emit("sendKpiEmail", data.data.encrypt.success);
                // }
                this.isShow = false;
                this.handleCostCheck = false;
                this.$toaster.success("Saved Successfully.");
                if (self.contactEmail) {
                  let userName = self.$store.getters["user/user"];
                  let userNameString = `${userName.firstName} ${userName.lastName} `;
                  let subject = "Enquiry";
                  let fullyDilutedEquityStanding = self.value.data
                    .equity_standing
                    ? self.value.data.equity_standing
                    : 0;
                  let fullAmount = self.value.data.amount
                    ? self.value.data.amount
                    : 0;
                  let fullyDilutedEquity =
                    Number(currentCompany.ownership) +
                    Number(fullyDilutedEquityStanding);
                  fullyDilutedEquity = fullyDilutedEquity
                    ? fullyDilutedEquity
                    : "";
                  let amountInvested =
                    Number(currentCompany.cost) + Number(fullAmount);
                  amountInvested = amountInvested ? amountInvested : "";
                  let currentData;
                  let updateData =
                    "The current number of shares\nThe company's current valuation";
                  if (
                    fullyDilutedEquity ||
                    amountInvested ||
                    self.lastFundingRoundDate
                  ) {
                    currentData = `I currently show that:\n\n`;
                    if (fullyDilutedEquity) {
                      currentData += `Current Fully Diluted Equity: ${fullyDilutedEquity}%\n`;
                    } else {
                      updateData += "\nMy current fully diluted equity";
                    }
                    if (amountInvested) {
                      currentData += `Current Amount Invested: $${amountInvested} USD\n`;
                    } else {
                      updateData += "\nMy current amount invested";
                    }
                    if (self.lastFundingRoundDate) {
                      currentData += `Date of last round of Funding: ${self.lastFundingRoundDate}`;
                    } else {
                      updateData += "\nThe date of your last round of funding";
                    }
                    currentData += `\n\nPlease correct any of the data above and update me to the below, if possible.\n\n`;
                  } else {
                    currentData =
                      "\n\nPlease update me to the below, if possible.\n\n";
                    updateData +=
                      "\nMy current fully diluted equity\nMy current amount invested\nThe date of your last round of funding";
                  }
                  // let body = `Hi,\nI’m updating my files and was hoping to get my current standing with my investment in ${
                  //   self.company_name
                  // }.\n\n${currentData ||
                  //   ""} Please update the details below.\n\nMy current fully diluted equity\nThe current number of shares, if applicable.\nThe company's current valuation\nThe date of your last round of funding.\n\n Sincerely,\n${userNameString}`;
                  let body = `Hi we are reaching out on behalf of ${userNameString} to validate a bit of information.\n\nfiifi will only send emails when you have closed a new round of funding or something major has happened. This is great to keep my files up to speed and to be the most helpful to you.\n\nWould you be willing to share my current investment standing so I can update my files with ${self.company_name}?\n\n${currentData}${updateData}\n\nI will not bother you in the future with this info as you are a new investment I wanted to get this info to start things off.\n\nSincerely,\n${userNameString}`;
                  body = encodeURIComponent(body);
                  self.emailString = `mailto:${self.contactEmail}?subject=${subject}&body=${body}`;
                  // self.investmentSubmit = true;
                }
                self.saveFiles(inserteddata);
                this.handleCancel()
              })
              .catch(err => {
                console.log(err);
                self.isSaving = false;
              });
          })
          .catch(err => {
            self.isSaving = false;
            console.log({ err });
          });
      } else {
        let updateData = JSON.parse(JSON.stringify(this.value.data));

        try {
          const x = self.value.data.transaction_date
            ? self.value.data.transaction_date
            : new Date();
          updateData.transaction_date = x.local(); //.format("MM/DD/YYYY");
        } catch (e) {}

        let updateEquityStanding;
        if (
          this.investmentData.hasOwnProperty("equity_standing") &&
          this.investmentData.equity_standing.value
        ) {
          updateEquityStanding = JSON.parse(
            JSON.stringify(this.investmentData.equity_standing)
          );
          updateEquityStanding.value = this.value.data.equity_standing
            ? this.value.data.equity_standing
            : "";
        } else {
          if (this.value.data.equity_standing != "") {
            updateEquityStanding = {
              _id: 0,
              value: this.value.data.equity_standing
            };
          }
        }
        updateData.equity_standing = updateEquityStanding
          ? JSON.parse(JSON.stringify(updateEquityStanding))
          : "";
        if (updateData.equity_standing == "") {
          delete updateData.equity_standing;
        }
        self.$store
          .dispatch("investment/updateInvestment", updateData)
          .then(resp => {
            if (self.$parent && self.$parent.transactionDetails) {
              let data = self.$parent.handleParseData();
              self.$parent.tabulator.updateData(data);
            }
            if (
              self.$parent &&
              self.$parent.$refs.noteRef &&
              self.$parent.$refs.noteRef
            )
              self.$parent.$refs.noteRef.getNotes();
            // if (
            //   self.context == "company-profile" &&
            //   (self.investmentData.amount != self.value.data.amount ||
            //     (self.investments.length > 1 &&
            //       self.value.data.equity_standing != "") ||
            //     self.investments.length == 1)
            // )
            if (
              self.context == "company-profile" &&
              (self.investmentData.amount != self.value.data.amount ||
                (!self.investmentData.equity_standing &&
                  self.value.data.equity_standing != "") ||
                (self.investmentData.equity_standing &&
                  self.investmentData.equity_standing.value !=
                    self.value.data.equity_standing))
            ) {
              self.handleCostCheck = true;
              self.handleCost();
            }
            let index = self.investments.findIndex(item => {
              return item._id == self.value.data._id;
            });
            let serverData = {};
            if (
              (!self.valueCheck &&
                self.currentCompany.value != self.value.data.currentValue) ||
              (index == 0 && !self.handleCostCheck)
            ) {
              serverData._id = self.currentCompany._id;
              serverData.__v = self.currentCompany.__v;
              serverData.value = Number(self.value.data.currentValue);
              if (index == 0) {
                serverData.initial_investment = self.value.data.transaction_date
                  ? self.value.data.transaction_date
                  : new Date();
              }
            } else {
              serverData._id = self.currentCompany._id;
              serverData.__v = self.currentCompany.__v;
            }
            let path = "company/apiPatchCompanyInst";
            this.$store.dispatch(path, serverData).then(response => {
              self.$store
                .dispatch("portfolio/_apiFetchPortfolio")
                .then(data => {
                  if (
                    self.currentCompany.value != self.value.data.currentValue
                  ) {
                    this.$toaster.success("Current Value Updated");
                  }
                });
            });

            api
              .get(`/portfolio/investments/${self.value.data.portfolio_item}`)
              .then(data => {
                this.$toaster.success("Saved successfully.");
                self.$emit("investment-save", data.data.encrypt.success);
                this.isShow = false;
                this.handleCostCheck = false;
                self.$store.dispatch("investment/start", null, { root: true });
                self.saveFiles(self.investmentData);
                this.handleCancel();
              })
              .catch(err => {
                console.log(err);
                self.isSaving = false;
              });
          })
          .catch(err => {
            self.isSaving = false;
            console.log({ err });
          });
      }
    },
    saveFiles(savedDoc) {
      let self = this;
      let filePayload = {
        files: [],
        data: []
      };
      _.forEach(this.files.add, item => {
        if (item) {
          filePayload.files.push(item);
          filePayload.data.push({
            _id: item._id,
            name: item.name,
            collection_name: "investment",
            document_id: savedDoc._id,
            portfolio_item: savedDoc.portfolio_item,
            link_type: "File"
          });
        }
      });
      _.forEach(self.url.add, item => {
        if (item) {
          filePayload.files.push(null);
          filePayload.data.push({
            _id: item._id,
            name: item.name,
            collection_name: "investment",
            document_id: savedDoc._id,
            portfolio_item: savedDoc.portfolio_item,
            link_type: "URL",
            url: item
          });
        }
      });

      if (!filePayload.data.length) {
        this.updateFiles(savedDoc);
        return;
      }
      self.$store.dispatch("file/createFile", filePayload).then(
        item => {
          self.$store.dispatch("file/start", null, { root: true });
          if (
            item.data.encrypt.limitExceededMessage &&
            item.data.encrypt.limitExceededMessage.length > 0 &&
            item.data.encrypt.limitExceededMessage == "Storage Limit Exceeded"
          ) {
            self.$toaster.error(
              "Storage limit exceeded. Upgrade your plan to add more"
            );
          }
          self.updateFiles(savedDoc);
        },
        error => {
          this.isSaving = false;
        }
      );
    },
    handleCancel() {
      // let serverData = JSON.parse(JSON.stringify(this.value));
      // console.log("serverData : ", serverData);
      this.isShow = false;
      this.isSaving = false;
      this.value.data = {};
      this.isVerified = false;
      this.files = {
        add: [],
        update: [],
        delete: []
      };
      this.url = {
        add: [],
        update: [],
        delete: []
      };
      this.urlValue = "";
      this.typeUrlCheck = false;
    },
    onlyForCurrency($event) {
      // console.log($event.keyCode); //keyCodes value
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;

      // only allow number and one dot
      if (
        (keyCode < 48 || keyCode > 57) &&
        (keyCode !== 46 || this.value.data.pricePerShare.indexOf(".") != -1)
      ) {
        // 46 is dot
        $event.preventDefault();
      }

      // restrict to 2 decimal places
      if (
        this.value.data.pricePerShare != null &&
        this.value.data.pricePerShare.indexOf(".") > -1 &&
        this.value.data.pricePerShare.split(".")[1].length > 1
      ) {
        $event.preventDefault();
      }
    },
    handleCost() {
      const self = this;
      let ownerShipCheck = false;
      let callServer = false;
      if (this.value.isCreate) {
        if (
          self.value.data.amount &&
          // self.value.data.amount.length > 0 &&
          isNaN(self.value.data.amount) == false
        ) {
          self.handleCostCheck = true;
          let serverData = {};
          serverData.cost =
            this.currentCompany.cost + Number(self.value.data.amount);
          serverData._id = this.currentCompany._id;
          serverData.__v = this.currentCompany.__v;
          if (
            self.value.data.equity_standing &&
            self.value.data.equity_standing != "" &&
            isNaN(self.value.data.equity_standing) == false
          ) {
            serverData.ownership = this.currentCompany.ownership
              ? this.currentCompany.ownership +
                Number(self.value.data.equity_standing)
              : Number(self.value.data.equity_standing);
            ownerShipCheck = true;
            serverData.ownership =
              serverData.ownership > 100 ? 100 : serverData.ownership;
          }
          if (self.value.data.currentValue != self.currentCompany.value) {
            self.valueCheck = true;
            serverData.value = Number(self.value.data.currentValue);
          }
          if (
            self.investments.length == 0 &&
            (!self.currentCompany.initial_investment ||
              self.currentCompany.initial_investment == "-" ||
              self.currentCompany.initial_investment == "")
          ) {
            serverData.initial_investment = self.value.data.transaction_date
              ? self.value.data.transaction_date
              : new Date();
          }
          let path = "company/apiPatchCompanyInst";
          this.$store.dispatch(path, serverData).then(response => {
            self.$store.dispatch("portfolio/_apiFetchPortfolio").then(data => {
              ownerShipCheck
                ? this.$toaster.success("Cost and Ownership updated")
                : this.$toaster.success("Cost Updated");
              if (self.$parent && self.$parent.tabulator) {
                let data = self.$store.getters["portfolio/portfolioData"];
                self.$parent.tabulator.updateData(data);
              }
              self.valueCheck = false;
              return;
            });
          });
        } else {
          if (
            self.value.data.equity_standing &&
            self.value.data.equity_standing != "" &&
            isNaN(self.value.data.equity_standing) == false
          ) {
            self.handleCostCheck = true;
            let serverData = {};
            serverData._id = this.currentCompany._id;
            serverData.__v = this.currentCompany.__v;
            serverData.ownership = this.currentCompany.ownership
              ? this.currentCompany.ownership +
                Number(self.value.data.equity_standing)
              : Number(self.value.data.equity_standing);
            ownerShipCheck = true;
            serverData.ownership =
              serverData.ownership > 100 ? 100 : serverData.ownership;
            if (self.value.data.currentValue != self.currentCompany.value) {
              self.valueCheck = true;
              serverData.value = Number(self.value.data.currentValue);
            }
            if (
              self.investments.length == 0 &&
              (!self.currentCompany.initial_investment ||
                self.currentCompany.initial_investment == "-" ||
                self.currentCompany.initial_investment == "")
            ) {
              serverData.initial_investment = self.value.data.transaction_date
                ? self.value.data.transaction_date
                : new Date();
            }
            let path = "company/apiPatchCompanyInst";
            this.$store.dispatch(path, serverData).then(response => {
              self.$store
                .dispatch("portfolio/_apiFetchPortfolio")
                .then(data => {
                  this.$toaster.success("Ownership updated");
                  if (self.$parent && self.$parent.tabulator) {
                    let data = self.$store.getters["portfolio/portfolioData"];
                    self.$parent.tabulator.updateData(data);
                  }
                  self.valueCheck = false;
                  return;
                });
            });
          } else {
            if (
              !self.currentCompany.initial_investment ||
              self.currentCompany.initial_investment == "-" ||
              self.currentCompany.initial_investment == ""
            ) {
              if (self.investments && self.investments.length > 1) {
                return;
              }
              self.handleCostCheck = true;
              let serverData = {};
              serverData._id = this.currentCompany._id;
              serverData.__v = this.currentCompany.__v;
              serverData.initial_investment = self.value.data.transaction_date
                ? self.value.data.transaction_date
                : new Date();
              if (self.value.data.currentValue != self.currentCompany.value) {
                self.valueCheck = true;
                serverData.value = Number(self.value.data.currentValue);
              }
              let path = "company/apiPatchCompanyInst";
              this.$store.dispatch(path, serverData).then(response => {
                self.$store
                  .dispatch("portfolio/_apiFetchPortfolio")
                  .then(data => {
                    if (self.$parent && self.$parent.tabulator) {
                      let data = self.$store.getters["portfolio/portfolioData"];
                      self.$parent.tabulator.updateData(data);
                    }
                    self.valueCheck = false;
                    return;
                  });
              });
            }
          }
        }
      } else {
        // if (
        //   self.value.data.amount &&
        //   self.value.data.amount.length > 0 &&
        //   isNaN(self.value.data.amount) == false
        // ) {
        let serverData = {};
        let presentAmount =
          self.value.data.amount &&
          // self.value.data.amount.length > 0 &&
          isNaN(self.value.data.amount) == false
            ? Number(self.value.data.amount)
            : 0;
        let previousAmount =
          self.investmentData.amount &&
          // && self.investmentData.amount.length > 0
          !isNaN(self.value.data.amount)
            ? Number(self.investmentData.amount)
            : 0;
        let finalCost = 0;
        if (presentAmount != previousAmount) {
          callServer = true;
          if (presentAmount > previousAmount) {
            finalCost = presentAmount - previousAmount;
            serverData.cost = this.currentCompany.cost + finalCost;
          } else {
            finalCost = previousAmount - presentAmount;
            serverData.cost =
              this.currentCompany.cost > 0
                ? this.currentCompany.cost - finalCost
                : 0;
          }
          serverData.cost = serverData.cost > 0 ? serverData.cost : 0;
        }
        serverData._id = this.currentCompany._id;
        serverData.__v = this.currentCompany.__v;
        let finalOwnership = 0;
        let presentEquityStanding =
          self.value.data.equity_standing &&
          self.value.data.equity_standing != "" &&
          self.value.data.equity_standing.length > 0 &&
          isNaN(self.value.data.equity_standing) == false
            ? Number(self.value.data.equity_standing)
            : 0;
        presentEquityStanding =
          presentEquityStanding > 100 ? 100 : presentEquityStanding;
        let previousEquityStanding =
          self.investmentData.equity_standing &&
          self.investmentData.equity_standing.value &&
          self.investmentData.equity_standing.value != "" &&
          self.investmentData.equity_standing.value.length > 0 &&
          isNaN(self.investmentData.equity_standing.value) == false
            ? Number(self.investmentData.equity_standing.value)
            : 0;
        previousEquityStanding =
          previousEquityStanding > 100 ? 100 : previousEquityStanding;
        if (presentEquityStanding != previousEquityStanding) {
          callServer = true;
          if (presentEquityStanding > previousEquityStanding) {
            finalOwnership = Number(
              (presentEquityStanding - previousEquityStanding).toFixed(1)
            );
            finalOwnership = finalOwnership > 100 ? 100 : finalOwnership;
            finalOwnership = finalOwnership < 0 ? 0 : finalOwnership;
            serverData.ownership = this.currentCompany.ownership
              ? Number(
                  (this.currentCompany.ownership + finalOwnership).toFixed(1)
                )
              : Number(finalOwnership.toFixed(1));
          } else {
            finalOwnership = Number(
              (previousEquityStanding - presentEquityStanding).toFixed(1)
            );
            serverData.ownership =
              this.currentCompany.ownership > 0
                ? Number(
                    (this.currentCompany.ownership - finalOwnership).toFixed(1)
                  )
                : 0;
          }
          serverData.ownership =
            serverData.ownership > 100 ? 100 : serverData.ownership;
          serverData.ownership =
            serverData.ownership > 0 ? serverData.ownership : 0;
        }
        if (self.value.data.currentValue != self.currentCompany.value) {
          self.valueCheck = true;
          serverData.value = Number(self.value.data.currentValue);
        }
        let index = self.investments.findIndex(item => {
          return item._id == self.value.data._id;
        });
        if (self.investments.length == 1 || index == 0) {
          serverData.initial_investment = self.value.data.transaction_date
            ? self.value.data.transaction_date
            : new Date();
        }
        if (callServer) {
          let path = "company/apiPatchCompanyInst";
          this.$store.dispatch(path, serverData).then(response => {
            self.$store.dispatch("portfolio/_apiFetchPortfolio").then(data => {
              // ownerShipCheck
              //   ? this.$toaster.success("Cost and Ownership updated")
              //   : this.$toaster.success("Cost Updated");
              self.valueCheck = false;
              return;
            });
          });
        }
      }
    },
    updateFiles(savedDoc) {
      let self = this;

      self.isSaving = true;

      let filePayload = {
        data: []
      };
      let fileUpdate = [...this.files.update, ...this.url.update];
      _.forEach(fileUpdate, item => {
        if (item._id && self.files.delete.indexOf(item._id) == -1) {
          if (item.link_type == "File") {
            filePayload.data.push({
              _id: item._id,
              name: item.name,
              collection_name: "investment",
              document_id: savedDoc._id,
              link_type: "URL"
            });
          } else {
            filePayload.data.push({
              _id: item._id,
              name: item.name,
              collection_name: "investment",
              document_id: savedDoc._id,
              link_type: "URL",
              url: item.url
            });
          }
        }
      });

      if (!filePayload.data.length) {
        this.deleteFiles(savedDoc);
        return;
      }

      self.$store.dispatch("file/updateFile", filePayload.data).then(
        item => {
          self.$store.dispatch("file/start", null, { root: true });
          this.deleteFiles(savedDoc);
          this.handleCancel();
        },
        error => {
          this.isSaving = false;
        }
      );
    },
    deleteFiles(savedDoc) {
      let self = this;
      let fileDelete = [...this.files.delete, ...this.url.delete];
      if (!fileDelete.length) {
        this.isSaving = false;
        this.value.isShow = false;
        this.url = { add: [], update: [], delete: [] };
        this.files = { add: [], update: [], delete: [] };
        return;
      }

      self.isSaving = true;

      let delCounter = 0;
      _.forEach(fileDelete, async item => {
        if (item) {
          let k = await self.$store.dispatch("file/deleteFile", item._id).then(
            item => {
              delCounter++;
              self.$store.dispatch("file/start", null, { root: true });
            },
            error => {
              delCounter++;
              this.isSaving = false;
            }
          );

          if (delCounter >= fileDelete.length) {
            this.isSaving = false;
            this.url = { add: [], update: [], delete: [] };
            this.files = { add: [], update: [], delete: [] };
            this.value.isShow = false;
          }
        }
      });
    },
  },
};
</script>
<style>

.addInvestmentTitle{
  padding:40px 0 0;
  line-height: 24px;
  font-size: 18px;
  color: #303133;
}

.previousValue {
  color: #828282 !important;
  font-size: 14px;
}
.switchValuationToggle {
  position: relative;
  display: inline-block;
  width: 45px;
  height: 20px;
  margin-left: 8px;
  margin-bottom: 0px !important;
}

.switchValuationToggle input {
  display: none;
}

.sliderValuationToggle {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: blue;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #707070;
  border-radius: 50px;
}

.sliderValuationToggle:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 2px;
  bottom: 2px;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  background-color: #6f6f6f;
  border: 1px solid #707070;
  border-radius: 50%;
}

input:checked + .sliderValuationToggle {
  background-color: #fff;
}

input:focus + .sliderValuationToggle {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .sliderValuationToggle:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(23px);
}

/*------ ADDED CSS ---------*/
.sliderValuationToggle:after {
  content: "No";
  color: #000;
  display: block;
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 60%;
  font-size: 11px;
  line-height: 14px;
  font-family: Verdana, sans-serif;
}

input:checked + .sliderValuationToggle:after {
  content: "Yes";
  font-size: 12px;
  line-height: 14px;
  color: #5baf47;
  left: 32%;
}
</style>